import { Instance, Styling, SearchFallback, Feedback } from './types';

// Define the Config interface
interface Config {
	webhookUrl: string; // Webhook URL
	pollingUrl: string; // Polling URL for checking query status
	readAloudUrl: string; // URL for read-aloud functionality
	agentId: string; // Agent ID
	wafEnabled?: boolean; // Whether WAF is enabled
	debug: boolean; // Debug mode
	instances: Instance[]; // Array of instances
	styling: Styling; // Styling configuration
	loadingText?: string; // Custom loading text
	SearchFallback?: SearchFallback; // Fallback configuration for search
	feedback? : Feedback; // Feedback configuration
	persistResults?: string; // Persists results between pages, or at source only
	showSources?: boolean; // Show sources for results
	readAloudFileUrl: string; // URL for loading read-aloud audio files
}

const config: Config = {
	webhookUrl: 'https://api.ai.onliberty.app/api/v1/agents/search/{agentId}',
	pollingUrl: 'https://api.ai.onliberty.app/api/v1/result/{taskId}',
	readAloudUrl: 'https://api.ai.onliberty.app/api/v1/speak',
	readAloudFileUrl: 'https://api.ai.onliberty.app/api/v1/speak/load/{taskId}',
	agentId: '',
	wafEnabled: false,
	debug: false,
	instances: [],
	styling: {},
};

export default config;
